export const getIframeSrc = () => {
    const {tt: {config: {dealerId, storeId, iframeBaseUrl}}} = window;
    const container = document.getElementById("tiretutorSearch");
    const resultPageUrl = container.getAttribute("data-result-page-url");
    if (!resultPageUrl) {
        throw new Error(
            "TireTutor Integration: You need to set a 'data-result-page-url' attribute on your search container div."
        );
    }
    let iframeSrc = `${iframeBaseUrl}/integrations/dealer-search/${dealerId}?searchOnly=true&resultPageUrl=${encodeURIComponent(
        resultPageUrl
    )}`;
    if (storeId) iframeSrc = `${iframeSrc}&storeId=${storeId}`;
    return iframeSrc;
};
